import React from 'react';
import { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/settings/subtypes/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/settings/subtypes';

const Home: NextPage = () => (
  <>
    <NskHead title="案件タイプ設定" />
    <Component />
  </>
);

export default Home;
